import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const UnknownErrorTitle: FC<IOuter> = () => (
  <FormattedMessage id="empty-state.something-went-wrong-title.new-screen" />
);

export const NewUnknownErrorTitle: FC<IOuter> = () => <FormattedMessage id="empty-state.server-error-title" />;
